<div class="edit-fav-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 id="FPWModalLabel">Enter a new name</h2>
    </div>
  </div>

  <form role="form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <div class="form-group  mg-top-24">
          <input type="text" class="form-control" id="favName" formControlName="favName" maxlength ="25"/>
          <app-validation-message [control]="form.controls.favName" class="form-error" [updateOn]="updateTrigger.Dirty"></app-validation-message>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <div class="form-group mg-top-24">
        <button type="submit" class="btn wb-btn-default center-block  send-reset-email-btn" [disabled]="loading || !form.valid">
          Rename and Continue
          <span *ngIf="loading" class="loading-animation"></span>
        </button>
      </div>
    </div>
  </div>
  </form>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="form-group">
        <button (click)="childClosed()" class="btn wb-btn-outline center-block  send-reset-email-btn"> Cancel</button>
      </div>
    </div>
  </div>
</div>
